import { render, staticRenderFns } from "./etapas.vue?vue&type=template&id=437db3a9&"
import script from "./etapas.vue?vue&type=script&lang=js&"
export * from "./etapas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports